import {
    BillingAdjustmentIssueType,
    DamageIssueType,
    DeliveryIssueTypeDomestic,
    EskerOrderIssueType,
    InvoiceIssueTypeDomestic,
    ItemOrQuantityIssueTypeDomestic,
    LargeInstrumentWarehouseIssueType,
    NatureOfComplaintDomestic,
    OrderEntryIssueTypeDomestic,
    ProductDatingUponReceiptIssueTypeDomestic,
    TemperatureIssueType
} from '@cod-monorepo/interfaces';

export const config = {
    [NatureOfComplaintDomestic.ORDER_ENTRY]: {
        label: 'Revise Order Entry Issue Type as a result of Investigation?',
        options: Object.values(OrderEntryIssueTypeDomestic),
        hidden: [
            OrderEntryIssueTypeDomestic.WRONG_BILL_TO_SHIP_TO_ACCOUNT_DOM,
            OrderEntryIssueTypeDomestic.PLANNER_ERROR_DOM,
            OrderEntryIssueTypeDomestic.REFUSED_SHIPMENT_DOM,
            OrderEntryIssueTypeDomestic.CUSTOMER_ORDERED_WRONG_MATERIAL_DOM
        ]
    },
    [NatureOfComplaintDomestic.ITEM_OR_QUANTITY]: {
        label: 'Revise Item or Quantity Issue Type as a result of Investigation?',
        options: Object.values(ItemOrQuantityIssueTypeDomestic)
    },
    [NatureOfComplaintDomestic.PRODUCT_DATING]: {
        label: 'Revise Product Dating Issue Type as a result of Investigation?',
        options: Object.values(ProductDatingUponReceiptIssueTypeDomestic)
    },
    [NatureOfComplaintDomestic.PRODUCT_DAMAGE]: {
        label: 'Revise Product Damage Issue Type as a result of Investigation?',
        options: Object.values(DamageIssueType)
    },
    [NatureOfComplaintDomestic.PRODUCT_TEMPERATURE]: {
        label: 'Revise Product Temperature Issue Type as a result of Investigation?',
        options: Object.values(TemperatureIssueType)
    },
    [NatureOfComplaintDomestic.DELIVERY]: {
        label: 'Revise Delivery Issue Type as a result of Investigation?',
        options: Object.values(DeliveryIssueTypeDomestic)
    },
    [NatureOfComplaintDomestic.INVOICE_ERROR]: {
        label: 'Revise Invoice Error Issue Type as a result of Investigation?',
        options: Object.values(InvoiceIssueTypeDomestic)
    },
    [NatureOfComplaintDomestic.BILLING_ADJUSTMENT]: {
        label: 'Revise Billing Adjustment Issue Type as a result of Investigation?',
        options: Object.values(BillingAdjustmentIssueType)
    },
    [NatureOfComplaintDomestic.ESKER]: {
        label: 'Revise Esker Issue Type as a result of Investigation?',
        options: Object.values(EskerOrderIssueType)
    },
    [NatureOfComplaintDomestic.LARGE_INSTRUMENT_WAREHOUSE]: {
        label: 'Revise Large Instrument Warehouse Issue Type as a result of Investigation?',
        options: Object.values(LargeInstrumentWarehouseIssueType)
    }
} as {
    [key in NatureOfComplaintDomestic]: {
        label: string;
        options: string[];
        hidden?: string[];
    };
};
